<template>
  <b-row v-if="$can('GetWalletDetaileList', 'Wallet')">
    <b-col cols="12">
      <h3 class="mb-3">تراکنش های کیف پول کاربر</h3>
    </b-col>
    <b-col cols="12" class="mb-1">
      <filters-wrapper @submitFilters="getUserWalletDetails">
        <search-input
          inputId="createByFullName"
          inputLabel="جستجوی فرد انجام دهنده"
          inputPlaceholder="نام کاربر"
          :inputValue="walletDetailsFilters.createByFullName"
          v-model="walletDetailsFilters.createByFullName"
          @enter="getUserWalletDetails"
        ></search-input>
        <search-input
          inputId="descriptionFilter"
          inputLabel="توضیحات تراکنش"
          inputPlaceholder="توضیحات تراکنش"
          :inputValue="walletDetailsFilters.description"
          v-model="walletDetailsFilters.description"
          @enter="getUserWalletDetails"
        ></search-input>
        <custom-date-picker
          inputLabel="تاریخ انجام تراکنش"
          inputPlaceholder="تاریخ ایجاد"
          inputId="roadmapGroupCreateDate"
          class="w-24 filters-width"
          @getSelectedDate="setSelectedDate"
        ></custom-date-picker>
      </filters-wrapper>
    </b-col>
    <b-col cols="12">
      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="walletTransactionsList"
        responsive
        :fields="myTableColumns"
        primary-key="id"
        show-empty
        bordered
        striped
        empty-text="موردی موجود نیست!"
      >
        <template #cell(description)="data">
          <span class="d-flex align-items-center justify-content-center">
            {{ data.item.description ? data.item.description : "-" }}
          </span>
        </template>
        <template #cell(createByFullName)="data">
          {{ data.item.createByFullName || userFullName }}
        </template>
        <template #cell(price)="data">
          <b-badge
            style="font-weight: normal !important"
            :variant="data.item.price > 0 ? 'success' : 'danger'"
          >
            <bdi>
              {{
                Intl.NumberFormat("en-US").format(
                  data.item.price < 0 ? data.item.price * -1 : data.item.price
                )
              }}
            </bdi>
            <span style="margin-right: 0.6rem"> تومان </span>
          </b-badge>
        </template>
        <template #cell(walletAction)="data">
          <span class="d-flex align-items-center justify-content-center">
            <feather-icon
              size="18"
              :class="data.item.price > 0 ? 'text-success' : 'text-danger'"
              :icon="data.item.price > 0 ? 'ArrowUpIcon' : 'ArrowDownIcon'"
            />
          </span>
        </template>
        <template #cell(createDate)="data">
          <span class="d-flex align-items-center justify-content-center">
            {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
            -
            {{
              new Date(data.item.createDate).toLocaleTimeString("fa-IR", {
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
          </span>
        </template>
      </b-table>
    </b-col>
    <b-col
      cols="12"
      class="d-flex align-items-center justify-content-center py-2"
    >
      <b-pagination
        v-model="walletDetailsFilters.pageNumber"
        :total-rows="walletTransactionTotalCount"
        :per-page="walletDetailsFilters.count"
        first-number
        last-number
        class="mb-0 mt-1 mt-sm-0"
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            style="transform: rotate(180deg)"
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </b-col>
  </b-row>
</template>
<script>
export default {
  mounted() {
    this.getUserWalletDetails();
  },
  props: {
    walletUserId: {
      type: [Number, String],
      required: true,
    },
    userFullName: {
      type: String,
      required: false,
      default: "-",
    },
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getUserWalletDetails();
      },
    },
  },
  data() {
    return {
      walletDetailsFilters: {
        pageNumber: 1,
        count: 10,
        userId: this.walletUserId,
        fullName: null,
        createDate: null,
        description: null,
        byUserId: null,
        createByFullName: null,
      },
      walletTransactionTotalCount: null,
      walletTransactionsList: null,
      myTableColumns: [
        {
          key: "fullName",
          label: "نام کاربر",
        },
        {
          key: "createDate",
          label: "تاریخ ثبت تراکنش",
        },
        {
          key: "createByFullName",
          label: "انجام شده توسط",
        },
        {
          key: "walletAction",
          label: "افزایش/کاهش",
        },
        {
          key: "price",
          label: "مبلغ تراکنش",
        },
        {
          key: "description",
          label: "توضیحات تراکنش",
        },
      ],
    };
  },
  methods: {
    setSelectedDate(date) {
      if (date) {
        this.walletDetailsFilters.createDate = new Date(date).toISOString();
      } else {
        this.walletDetailsFilters.createDate = null;
      }
    },
    async getUserWalletDetails() {
      try {
        this.isLoading = true;
        let _this = this;
        let getUserWalletDetails = new GetUserWalletDetails(_this);
        getUserWalletDetails.setRequestParamDataObj(_this.walletDetailsFilters);
        await getUserWalletDetails.fetch((res) => {
          _this.walletTransactionTotalCount = res.total;
          _this.walletTransactionsList = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.walletDetailsFilters.pageNumber;
    },
  },
  components: {
    BRow,
    BCol,
    BTable,
    BBadge,
    BPagination,
    FiltersWrapper,
    SearchInput,
    CustomDatePicker,
  },
};
import FiltersWrapper from "@/views/components/Utils/FiltersWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import { GetUserWalletDetails } from "@/libs/Api/Wallet";
import { BRow, BCol, BTable, BBadge, BPagination } from "bootstrap-vue";
</script>
<style scoped>
.custom-clear-btn {
  border: 1px solid #d8d6de !important;
  border-top-right-radius: 0.357rem !important;
  border-bottom-right-radius: 0.357rem !important;
}
</style>
